export default function remap(
  value: number,
  min1: number,
  max1: number,
  min2: number,
  max2: number,
  clamp: boolean = false
): number {
  const result = min2 + ((value - min1) * (max2 - min2)) / (max1 - min1);
  
  if (clamp) {
    return Math.max(min2, Math.min(max2, result));
  }
  
  return result;
}
